interface PurchaseVendorServerData {
  vendor_id?: string | null;
  vendor_name?: string | null;
}

class PurchaseVendorModel {
  private _serverData: any;

  constructor(serverData: any = null) {
    this._serverData = serverData;
  }

  get id() {
    if (typeof this._serverData === 'object' && this._serverData !== null) {
      return String((this._serverData as PurchaseVendorServerData).vendor_id ?? '').trim();
    }

    return '';
  }

  get name() {
    if (typeof this._serverData === 'string') {
      return this._serverData.trim();
    }

    if (typeof this._serverData === 'object' && this._serverData !== null) {
      return String((this._serverData as PurchaseVendorServerData).vendor_name ?? '').trim();
    }

    return String(this._serverData ?? '').trim();
  }

  get option() {
    return {
      vendor_id: this.id,
      vendor_name: this.name,
    };
  }

  getRawData() {
    return this._serverData;
  }

  static fromServerData(serverData: any) {
    return new PurchaseVendorModel(serverData);
  }
}

class PurchaseVendorsListModel {
  private _vendors: PurchaseVendorModel[];

  constructor(serverData: any = null) {
    if (Array.isArray(serverData)) {
      this._vendors = serverData.map((vendor) => PurchaseVendorModel.fromServerData(vendor));
      return;
    }

    this._vendors = [];
  }

  get vendors() {
    return this._vendors;
  }

  get names() {
    return this._vendors
      .map((vendor) => vendor.name)
      .filter((name) => !!name);
  }

  get options() {
    return this._vendors
      .map((vendor) => vendor.option)
      .filter((vendor) => vendor.vendor_id && vendor.vendor_name);
  }

  getRawData() {
    return this._vendors.map((vendor) => vendor.getRawData());
  }

  static fromServerData(serverData: any) {
    return new PurchaseVendorsListModel(serverData);
  }

  static createEmpty() {
    return new PurchaseVendorsListModel();
  }
}

export default PurchaseVendorsListModel;
export { PurchaseVendorModel };
